import React, {forwardRef, useEffect} from "react";
import {useDispatch} from "react-redux";
import {InputMain} from "./inputMain";
import {SelectMain} from "./selectMain";
import {CountryList, FindLoad} from "utils";
import axios from "axios";
import {httpRequestsOnLoadActions} from "store";
import {AddressInputMain} from "./addressInputMain";
import {Loader} from "../loaders";

const ADDRESS_LOAD = "ADDRESS_LOAD";

export const AddressInput = forwardRef(
    (
        {
            oneInput,
            placeholder,
            disabled,
            noSuite,
            control,
            required,
            allValues,
            setValue,
        },
        ref,
    ) => {
        const dispatch = useDispatch();
        const load = FindLoad(ADDRESS_LOAD);

        useEffect(() => {
            const params = {...allValues};

            let formattedAddress = "";
            if (params?.street) formattedAddress += `${params.street}, `;
            if (params?.city) formattedAddress += ` ${params.city}, `;
            if (params?.state) formattedAddress += ` ${params.state}, `;
            if (params?.zip) formattedAddress += ` ${params.zip}, `;
            if (params?.country) formattedAddress += ` ${params.country}`;
            params["formattedAddress"] = formattedAddress;

            setValue("address", params);
        }, [
            allValues?.street,
            allValues?.city,
            allValues?.state,
            allValues?.zip,
            allValues?.country,
        ]);

        const handleSelect = async (value) => {
            dispatch(httpRequestsOnLoadActions.appendLoading(ADDRESS_LOAD));
            await axios
                .post(`/address`, {address: value}, {auth: true})
                .then((response) => {
                    const params = {
                        ...allValues,
                    };
                    params["formattedAddress"] = response.data.formattedAddress || "";
                    params["lat"] = response.data.lat || "";
                    params["lng"] = response.data.lng || "";
                    params["city"] = response.data.city;
                    params["country"] = response.data.country || "";
                    params["state"] = response.data.state || "";
                    params["street"] = response.data.street || "";
                    params["zip"] = response.data.zip;

                    if (response.data.unitNumber) params["unitNumber"] = response.data.unitNumber || "";
                    setValue("address", params);
                })
                .finally(() => {
                    dispatch(httpRequestsOnLoadActions.removeLoading(ADDRESS_LOAD));
                });
        };
        return (
            <div className={"flex-column"} ref={ref}>
                <AddressInputMain
                    name="address.street"
                    control={control}
                    labelHeader="Phycical Address"
                    placeholder="Ex. 123 Main St"
                    onSelect={handleSelect}
                    loadType={ADDRESS_LOAD}
                    rules={{
                        required: required && "Street is required",
                    }}
                />

                {!noSuite && (
                    <InputMain
                        name="address.unitNumber"
                        control={control}
                        labelHeader="Unit/Suit #"
                        disabled={disabled}
                        placeholder="Ex. Apt 4B"
                    />
                )}

                {!oneInput && (
                    <div>
                        <InputMain
                            name="address.city"
                            control={control}
                            labelHeader="City"
                            disabled={disabled}
                            placeholder="Ex. Los Angeles"
                            rules={{
                                required: required && !allValues?.city && "City is required",
                            }}
                            endAdornment={
                                load?.length && (
                                    <Loader
                                        styles={{
                                            position: "absolute",
                                            right: 10,
                                            width: 15,
                                            height:15,
                                            minWidth: 15,
                                            minHeight: 15,
                                        }}
                                    />
                                )
                            }
                        />

                        <InputMain
                            name="address.state"
                            control={control}
                            labelHeader="State"
                            disabled={disabled}
                            placeholder="Ex. California"
                            endAdornment={
                                load?.length && (
                                    <Loader
                                        styles={{
                                            position: "absolute",
                                            right: 10,
                                            width: 15,
                                            height:15,
                                            minWidth: 15,
                                            minHeight: 15,
                                        }}
                                    />
                                )
                            }
                        />

                        <div className={"flex"} style={{gap: 16}}>
                            <SelectMain
                                list={CountryList}
                                renderLabel={(option) => option?.name}
                                name="address.country"
                                control={control}
                                placeholder="Ex. United States"
                                labelHeader="Country"
                                loadType={ADDRESS_LOAD}
                                selectedValue={'id'}
                                rules={{
                                    required: required && "Country is required",
                                }}
                            />

                            <InputMain
                                name="address.zip"
                                control={control}
                                labelHeader="Zip Code"
                                disabled={disabled}
                                placeholder="Ex. 90001"
                                endAdornment={
                                    load?.length && (
                                        <Loader
                                            styles={{
                                                position: "absolute",
                                                right: 10,
                                                width: 15,
                                                height:15,
                                                minWidth: 15,
                                                minHeight: 15,
                                            }}
                                        />
                                    )
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    },
);
